import { Injectable } from "@angular/core";
import { StatusItem } from "../components/dashboard-widget/dashboard-widget.component";

@Injectable({
    providedIn: "root",
})
export class StatusCountService {
    getStatusCounts<T extends string>(statuses: Record<T, number>, icon = null) {
        const result = { totalCount: 0, statusItems: [] as StatusItem<T>[] };

        Object.entries(statuses).forEach(([name, data]: [T, number]) => {
            if (data) {
                result.totalCount += data;
                result.statusItems.push({
                    icon,
                    label: name,
                    itemCount: data,
                });
            }
        });

        return result;
    }
}
